/**!
 * Apricot
 * @version 4.5.23
 * @author Mitra Assadi
 * @license
 * Copyright (c) 2023 The College Board
 */

/* ========================================================================
 * Apricot's Base
 * ======================================================================== */

// SCSS
import "../scss/includes/apricot-base.scss";

window.cb = window.cb || {};
window.cb.apricot = window.cb.apricot || {};
window.cb.apricot.version = "4.5.23";

// javaScript
export default {};
